import React from 'react';
import { LayerTypeDTO } from 'business/models/Models';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import LayersSelectionParent from 'components/commandpanel/Layers/LayersSelectionParent';
import { getLinkedLayers } from 'utils/Global';
import { setSelectedLayerId } from 'redux/reducers/experimentDataReducer';
import {
  selectExperimentLayers,
  selectSelectedLayerId,
} from 'redux/selectors/ExperimentStateSelector';
function GridLinkedLayer() {
  const dispatch = useRMDispatch();
  const _selectedLayerId = useRMSelector(selectSelectedLayerId);
  const experimentLayers = useRMSelector(selectExperimentLayers);

  function getChildLInkedLayers() {
    const selectedLayer = experimentLayers.find((lyr) => lyr.id === _selectedLayerId);
    if (selectedLayer.type != LayerTypeDTO.Grid) {
      return null;
    }

    const linkedLayers = getLinkedLayers(experimentLayers, selectedLayer);

    return linkedLayers;
  }

  function handleLayerSelection(layerId) {
    dispatch(setSelectedLayerId(layerId));
  }

  return (
    <LayersSelectionParent
      layers={getChildLInkedLayers()}
      selectedParentLayerId={_selectedLayerId}
      handleSelection={handleLayerSelection}
      isSubGrid={true}
      customStyle={{
        paddingLeft: '0px',
        paddingRight: '0px',
        height: '24.21%',
      }}
    />
  );
}

export default GridLinkedLayer;
